import React from 'react';
import fb from "../../../../../../images/verizon/email_app/fb.png";
import x from "../../../../../../images/verizon/email_app/x.png";
import yt from "../../../../../../images/verizon/email_app/yt.png";
import inst from "../../../../../../images/verizon/email_app/inst.png";

const FooterSocialMenu = () => {
  return (
    <ul className="email_footer-menu -social">
      <li><img src={ fb } alt="" /></li>
      <li><img src={ x } alt="" /></li>
      <li><img src={ yt } alt="" /></li>
      <li><img src={ inst } alt="" /></li>
    </ul>
  );
}

export default FooterSocialMenu;